export default __webpack_public_path__ + "static/media/listbuilder-settings-selected.5c7849fd.svg";